/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from 'axios';
import {
    Toast
} from "vant";
import {
    getApiUrl
} from './config.js'

/** 
 * 请求失败后的错误统一处理 
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
    // 状态码判断
    switch (status) {
        // 401: 未登录状态，跳转登录页
        case 401:

            break;
            // 403 token过期
        case 403:

            break;
            // 404请求不存在
        case 404:
            Toast.fail('请求的资源不存在');
            break;
        case 500:
            Toast.fail('服务器错误');
            break;
        default:
            console.log(other);
    }
}

let baseURL = getApiUrl();

// 创建axios实例
var instance = axios.create({
    timeout: 1000 * 12,
    baseURL: baseURL,
});

// 设置post请求头
instance.defaults.headers.post['Content-Type'] = 'application/json';
if (localStorage.getItem('wellcee.did')) {
    instance.defaults.headers.common['Wellcee-DID'] = localStorage.getItem('wellcee.did');
}

// 响应拦截器
instance.interceptors.response.use(
    // 请求成功
    res => {
        if (res.status === 200) {
            if (res.data.code == 200) {
                return Promise.resolve(res.data);
            } else {
                Toast(res.data.msg);
            }
        } else {
            Promise.reject(res)
        }
    },
    // 请求失败
    error => {
        const {
            response
        } = error;
        if (response) {
            // 请求已发出，但是不在2xx的范围 
            errorHandle(response.status, response.data.message);
            return Promise.reject(response);
        } else {
            // 处理断网的情况
            // eg:请求超时或断网时，更新state的network状态
            // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
            // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
            if (!window.navigator.onLine) {
                Toast.fail('请求超时网络链接异常');
            } else {
                return Promise.reject(error);
            }
        }
    });

export default instance;